import { useStore } from 'react-redux';
import { usePersistentCallback } from './hooks';
import { useIsRendering } from './useIsRendering';
/**
 * useEventState - reads Redux state inside callbacks without causing re-renders
 * Only meant for event handlers/effects.
 */
export function useEventState(selector) {
    const store = useStore();
    const isRenderingRef = useIsRendering();
    const getState = usePersistentCallback(() => {
        if (process.env.NODE_ENV !== 'production' && isRenderingRef.current) {
            throw new Error('useEventState: selector called during render! Only use inside event handlers or effects.');
        }
        return selector(store.getState());
    });
    return getState;
}
